import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { ServiceRequestService } from '../../../../services/servicerequest.service';
import { HelpersService } from '../../../../services/helpers.service';

@Component({
  selector: 'app-workshop-jobcard-tag-select',
  templateUrl: './workshop-jobcard-tag-select.component.html',
  styleUrls: ['./workshop-jobcard-tag-select.component.scss']
})
export class WorkshopJobcardTagSelectComponent {
  @Input() jobcard: any = {};
  public tags: any[] = [];
  public linkedTags: any[] = [];
  public selectedTagIds: any[] = [];
  public label: string = 'Tags';
  @Output() tagToggled = new EventEmitter<any>();
  @Output() tagRemoved = new EventEmitter<any>();
  @Output() tagCount = new EventEmitter<any>();

  isOpen = false;

  constructor(private elementRef: ElementRef,

    private serviceRequest: ServiceRequestService,
    private helpersService: HelpersService,) { }

  ngOnInit() {
    console.log(this.jobcard);
    this.getTags();
    this.getServiceTags();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }


  getTags() {
    this.serviceRequest.getTags(this.helpersService.getPartnerId()).subscribe(res => {
      this.tags = res.map(tag => ({
        ...tag,
        value: tag.id,
        label: tag.tag,
      }));
      this.tagCount.emit(this.tags.length);
    });

  }

  getServiceTags() {
    if (this.jobcard?.id > 0) {
      this.serviceRequest.getServiceTags(this.jobcard.partnerID, this.jobcard.id).subscribe(res => {
        console.log('Existing tags for jobcard:', res);
        this.linkedTags = res;
        this.selectedTagIds = res.map((tag: any) => tag.id);
      });
    }
  }

  toggleDropdown(event: MouseEvent): void {
    event.stopPropagation();
    this.isOpen = !this.isOpen;
  }

  isSelected(tag: any): boolean {
    return this.linkedTags.some(lt => lt.id === tag.id);
  }

  toggleTag(tag: any): void {
    if (this.jobcard?.id > 0) {
      const isLinked = this.linkedTags.some(lt => lt.id === tag.id);
      if (isLinked) {
        this.linkedTags = this.linkedTags.filter(lt => lt.id !== tag.id);
        this.selectedTagIds = this.selectedTagIds.filter(id => id !== tag.id);
        this.serviceRequest.deleteServiceTags(this.jobcard.partnerID, this.jobcard.id, tag.id).subscribe(() => { });
      } else {
        this.linkedTags = [...this.linkedTags, tag];
        this.selectedTagIds = [...this.selectedTagIds, tag.id];
        const data = { TagID: tag.id };
        this.serviceRequest.saveServiceTags(this.jobcard.partnerID, this.jobcard.id, data).subscribe(() => { });
      }
    }
    else {
      const isLinked = this.linkedTags.some(lt => lt.id === tag.id);
      if (isLinked) {
        this.linkedTags = this.linkedTags.filter(lt => lt.id !== tag.id);
        this.selectedTagIds = this.selectedTagIds.filter(id => id !== tag.id);
      } else {
        this.linkedTags = [...this.linkedTags, tag];
        this.selectedTagIds = [...this.selectedTagIds, tag.id];
        const data = { TagID: tag.id };
      }
      this.tagToggled.emit(this.linkedTags);
    }
    this.isOpen = true;
  }

  removeTag(tag: any, event: MouseEvent): void {
    this.linkedTags = this.linkedTags.filter(lt => lt.id !== tag.id);
    this.selectedTagIds = this.selectedTagIds.filter(id => id !== tag.id);
    this.serviceRequest.deleteServiceTags(this.jobcard.partnerID, this.jobcard.id, tag.id).subscribe(() => { });
    this.isOpen = true;
  }
}
